import { createFileRoute } from '@tanstack/react-router'
import ConfirmEmailView from "../signup/ConfirmEmailView.tsx";

export const Route = createFileRoute('/confirm-email')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ConfirmEmailView />
}
